export default {
  CHANGE_TYPE: "CHANGE_TYPE",
  FLATTEN: "FLATTEN"
};
